<template>
  <div class="loader">
    <img v-if="type=='song'" src="../assets/image/updataBg.png" alt="">
    <img v-else src="../assets/image/updataBg1.png" alt="">
  </div>
</template>

<script>
  export default {
    name: 'App',
    props: {
      type: String,
    },
    data () {
      return {
      }
    },
    created(){
    }
  }
</script>
<style type="text/css" lang="scss">
  .loader {


  }
</style>



// WEBPACK FOOTER //
// src/components/bars.vue